import { Timezone, User } from './index';
import { RecordKeeper } from './recordkeeper';

export class Carrier {
    Id: number;
    Name: string;
    Address1: string;
    Address2: string;
    City: string;
    ZipCode: string;
    State: string;
    TimeZoneId: number;
    TimeZone: Timezone;
    PhoneNumber1: string;
    PhoneNumber2: string;
    ContactEmail: string;
    Fax: string;
    ContactFirstName: string;
    ContactLastName: string;
    Status: number;
    CarrierFleets: CarrierFleet[];
    CarrierDrivers: CarrierDriver[];
    CarrierUsers: CarrierUser[];
    RecordKeepers: RecordKeeper[];
    CarrierDateNow: string;
}

export class CarrierList {
    Id: number;
    Name: string;
}

export class CarrierFleet {
    Id: number;
    CarrierId: number;
    Carrier: Carrier;
    ServerId: number;
    FleetId: number;
    DisplayName: string;
}

export class CarrierFleetDriver {
    Id: number;
    CarrierFleetId: number;
    ExternalDriverId: number;
    DriverId: number;
    DisplayName: string;
}

export class CarrierPage {
    TotalNumber: number;
    List: Carrier[];
}

export class CarrierDriver {
    Id: number;
    CarrierId: number;
    DriverId: number;
    Name: string;
    IsApproved: boolean;
    Carrier: Carrier;
}

export class CarrierUser {
    Id: number;
    CognitoId: string;
    CarrierId: number;
    UserName: string;
    FirstName: string;
    LastName: string;
    Email: string;
    ActivatedDateTimeUtc: string;
}
